import React, {
  memo, useRef, useEffect, useState, useCallback, useMemo,
} from 'react';
import { string } from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import classNames from 'classnames';
import {
  handleKeyboardEvent,
  checkHtml,
  cleanHtml as cleanHtmlFun,
} from '../../../../../shared/utils/commonUtils';

const ConfirmationMessage = ({ confirmationMsg, className }) => {
  if (!confirmationMsg) {
    return null;
  }
  const cleanHtml = cleanHtmlFun(confirmationMsg);
  const isHtml = checkHtml(cleanHtml);
  const msgRef = useRef(null);
  const classes = classNames({
    'payment-result__content-info__confirmationMsg': true,
  }, className);
  if (isHtml) {
    return <div ref={msgRef} className={classes} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }
  const [ msgCollapse, setMsgCollapse ] = useState(false);
  const [ showToggleBar, setShowToggleBar ] = useState(false);
  useEffect(() => {
    const strLen = cleanHtml.length;
    setShowToggleBar(strLen > 128);
    setMsgCollapse(strLen > 128);
  }, [ cleanHtml.length, setMsgCollapse, setShowToggleBar ]);

  const toggleMsg = useCallback(() => {
    setMsgCollapse(!msgCollapse);
  }, [ msgCollapse, setMsgCollapse ]);

  const preStr = useMemo(() => cleanHtml.slice(0, 128), [ cleanHtml ]);
  const collapseStr = useMemo(() => cleanHtml.slice(128), [ cleanHtml ]);

  return <div ref={msgRef} className={classes}>
    {preStr}
    {!msgCollapse && collapseStr}
    { showToggleBar
    && <div className="toggle-bar"
      tabIndex="0"
      role="button"
      onKeyDown={handleKeyboardEvent(toggleMsg, [ 'Enter' ])} onClick={toggleMsg}>
      {
        !msgCollapse ? <span
          className="show-less">
          <Locale id="checkout.lib.components.text.seeLess" />
        </span>
          : <span className="show-more">
            <span className="toggle-bar__ellipsis">...</span>
            <span className="show-more__text">
              <Locale id="checkout.lib.components.text.seeMore" />
            </span>
          </span>
      }
    </div>}
  </div>;
};

ConfirmationMessage.propTypes = {
  confirmationMsg: string,
  className: string,
};

ConfirmationMessage.defaultProps = {
  confirmationMsg: '',
};

export default memo(ConfirmationMessage);
